import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextIcon from "@mui/icons-material/TextFields";
import { SuiteTypes } from "../../../interfaces/SuiteTypes";
import Row from "../../../components/layout/Row";
import Input from "../../../components/Input";
import { deleteTask, editTask } from "../../../api/task";
import { Task } from "../../../interfaces/TaskTypes";
import { Avatar, Box, DialogActions, MenuItem, Select } from "@mui/material";
import ButtonLoading from "../../../components/ButtonLoading";
import { toast } from "react-toastify";
import { createHistory } from "../../../api/history";
import { ActionTypeEnum } from "../../../interfaces/HistoryTypes";
import { mountHistory } from "../../../utils/history";
import { useParams } from "react-router-dom";
import moment from "moment-timezone";
import { colors } from "../../../assets/colors";

interface DialogShareProps {
  close: () => void;
  open: boolean;
  task: Task | null;
}
export default function DialogTask({ close, open, task }: DialogShareProps) {
  const { id } = useParams();

  const [title, setTitle] = React.useState(task?.title || "");
  const [editingTitle, setEditingTitle] = React.useState(false);

  const [description, setDescription] = React.useState(task?.description || "");
  const [editingDescription, setEditingDescription] = React.useState(false);

  const [status, setStatus] = React.useState(task?.status || "");
  const [loadingDelete, setLoadingDelete] = React.useState(false);

  const handleClose = () => {
    close();
  };

  const handleEndEditingTitle = () => {
    setEditingTitle(false);

    if (task) {
      let editedTask = {
        ...task,
        title,
      };

      editTask(task?.id, editedTask);
    }
  };
  const handleEndEditingDescription = () => {
    setEditingDescription(false);

    if (task) {
      let editedTask = {
        ...task,
        description,
      };

      editTask(task?.id, editedTask);
    }
  };

  const initialColumns = [
    "Todo",
    "Pronto pra fazer",
    "Em desenvolvimento",
    "Pronto para testes",
    "Em testes",
    "Finalizado",
  ];

  const changeStatus = (status: string) => {
    setStatus(status);

    if (task) {
      let editedTask = {
        ...task,
        status,
      };

      editTask(task?.id, editedTask);
    }
  };

  const handleDelete = () => {
    if (task) {
      setLoadingDelete(true);
      deleteTask(task?.id).then(() => {
        toast.success("Tarefa excluída com sucesso");
        createHistory(
          mountHistory(id || "", ActionTypeEnum.DELETE, "Tarefa: " + title)
        );
        close();
        setLoadingDelete(false);
      });
    }
  };

  function stringToColor(string: string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
  }

  function stringAvatar(name: string) {
    try {
      return {
        sx: {
          bgcolor: stringToColor(name),
        },
        children: `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`,
      };
    } catch (error) {
      return {
        sx: {
          bgcolor: stringToColor(name),
        },
        children: `${name.split(" ")[0][0]}`,
      };
    }
  }

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        style={styles.container}
        fullWidth
        fullScreen
      >
        <DialogTitle>
          <span style={styles.collumnName}>{task?.status}</span>

          <Row
            style={{
              flexDirection: "row",
              alignItems: "center",
              gap: 12,
            }}
          >
            <i className="material-icons" style={{ marginTop: 12 }}>
              credit_card
            </i>
            <Input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              onFocus={() => setEditingTitle(true)}
              onBlur={handleEndEditingTitle}
              disabledBorders={!editingTitle}
              onKeyPress={(e) => e.key === "Enter" && handleEndEditingTitle()} // Adiciona ao pressionar Enter
              variant="standard"
              style={{ fontSize: 20, fontWeight: 500 }}
            />
          </Row>

          <Select
            value={status}
            onChange={(e) => changeStatus(e.target.value)}
            displayEmpty
            style={{ width: "50%", height: 40, marginTop: 16 }}
          >
            {initialColumns.map((status) => (
              <MenuItem value={status}>{status}</MenuItem>
            ))}
          </Select>
        </DialogTitle>
        <DialogContent sx={styles.content}>
          <Row
            style={{
              flexDirection: "row",
              alignItems: "start",
              gap: 12,
            }}
          >
            <i className="material-icons" style={{ marginTop: 16 }}>
              notes
            </i>
            <Input
              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              onFocus={() => setEditingDescription(true)}
              onBlur={handleEndEditingDescription}
              disabledBorders={!editingDescription}
              multiline
              rows={5}
              variant="outlined"
            />
          </Row>

          <Row
            style={{
              flexDirection: "row",
              alignItems: "center",
              gap: 12,
              marginTop: 24,
            }}
          >
            <i className="material-icons">history</i>
            <span>Histórico</span>
          </Row>

          {task?.history?.map((history) => (
            <Box sx={{ width: "100%", marginTop: 2 }}>
              <Row
                style={{
                  width: "100%",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: 6,
                  marginTop: 12,
                }}
              >
                <Avatar {...stringAvatar(history.user || "")} />
                <span style={{ fontWeight: 500 }}>{history.user}</span>

                {history.type == "status" && (
                  <span style={{ color: colors.gray, fontSize: 12 }}>
                    alterou de <strong>{history.previousStatus}</strong> para{" "}
                    <strong>{history.newStatus}</strong>
                    {" | "}
                    {moment(history.date).format("DD/MM/YYYY HH:mm")}
                  </span>
                )}

                {history.type == "criou" && (
                  <span style={{ color: colors.gray, fontSize: 12 }}>
                    criou a tarefa
                  </span>
                )}
              </Row>
            </Box>
          ))}
        </DialogContent>
        <DialogActions>
          <ButtonLoading
            label="Excluir"
            isDelete
            onClick={handleDelete}
            loading={loadingDelete}
            color={"red"}
          />
          <ButtonLoading label="Confirmar" onClick={handleClose} />
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

const styles = {
  container: {
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",
    margin: 80,
  },

  content: {
    width: "100%",
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    marginTop: 2,
  },

  collumnName: {
    fontSize: 12,
    color: "#10957d",
    backgroundColor: "rgba(16, 149, 125, 0.15)",
    padding: 2,
    paddingLeft: 6,
    paddingRight: 6,
    borderRadius: 6,
  },
};
